import React, {useState, useEffect, forwardRef, useRef} from "react";
import InputField from '../atoms/InputField';
import Button from '../atoms/Button';
import '../../styles/Styles.css';

const Form = forwardRef(({ domain, setDomain, error, setError, setSettings, onclick, setButtonEnabled}, ref) => {

    const [btnEnable, setbtnEnable] = useState(setButtonEnabled);
    const [status, setStatus] = useState('processing');
    const inputRef = useRef(null);

    //console.log("Button status in child", setButtonEnabled);
    
    /*useEffect(() => {
      const pollInterval = 1000; // 1 second
        const maxAttempts = 30; // 30 seconds maximum
        let attempts = 0;
        
        const checkCaptchaStatus = async () => {
            const polling = setInterval(async () => {
                try {
                    attempts++;
                    if (attempts >= maxAttempts) {
                        clearInterval(polling);
                        setStatus('timeout');
                        return;
                    }
    
                    //http://localhost:80/emailsettings/Domain-Scan-Email-Settings/backend/controllers/checkRecaptcha.php
                    //domainscan/controllers/checkRecaptcha.php
                    const response = await fetch('http://localhost:80/emailsettings/Domain-Scan-Email-Settings/backend/controllers/checkRecaptcha.php', {
                        method: 'GET',
                        credentials: 'include',
                    });
                    const data = await response.json();
                    console.log('Polling response:', data);
    
                    if (data.status === 'success') {
                        clearInterval(polling);
                        setStatus('success');
                        setButtonEnabled(true);
                    } else if (data.status === 'fail' || data.status === 'timeout') {
                        clearInterval(polling);
                        setStatus(data.status);
                        setButtonEnabled(false);
                    }
                } catch (error) {
                    console.error('Error fetching reCAPTCHA status:', error);
                    clearInterval(polling);
                    setStatus('fail');
                }
            }, pollInterval);
    
            // Cleanup function
            return () => clearInterval(polling);
        };
    
        checkCaptchaStatus();

    }, []);*/

    useEffect(() => {
            
            const checkCaptchaStatus = async () => {
                    try {
                        //http://localhost:80/emailsettings/Domain-Scan-Email-Settings/backend/controllers/checkRecaptcha.php
                        ///domainscan/controllers/checkRecaptcha.php
                        const response = await fetch('/domainscan/controllers/checkRecaptcha.php', {
                            credentials: 'include',
                        });
            
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
            
                        const data = await response.json();
                        //console.log("Data:", data.status);
                        
                        if (data.status === 'pass') {
                            setStatus('pass')
                            //setError('');
                            //setButtonEnabled(true); // Enable button if CAPTCHA is successful
                            //console.log('Passed');
                        } else if (data.status === 'fail') {
                            setStatus('fail');
                            //setButtonEnabled(false);
                            //console.log('Verification Failed');
                            //console.log('waiting for google response');
                            //setError('reCAPTCHA verification failed');
                        } else if (data.status === 'processing'){
                            setStatus('processing');
                            //setButtonEnabled(false);
                            //console.log('waiting for google response');
                            //setError('reCAPTCHA verification failed, please try again or contact support.');
                        } else {
                            setStatus('timeout');
                            //console.log('Verification process timed out.');
                        }
            
                    } catch (error) {
                        console.error('Error checking captcha status:', error);
                    }
                };
            checkCaptchaStatus();
        }, []);

    /*useEffect(() => {
      if (btnEnable && inputRef.current) {
        inputRef.current.focus();
      }
    }, [btnEnable]);*/
 
        return (
                <div className='form-container' >
                        <div className="form-wrapper">
                            <InputField value={domain} onChange={(e) => {setDomain(e.target.value); setError(''); setSettings('');}} /*setButtonEnabled={status}*/ placeholder="Enter domain name" />
                            <Button onclick={onclick} setButtonEnabled={setButtonEnabled} type="button">GET SETTINGS</Button>
                        </div>

                        <div className="error-container">
                                {error && <div className="error-message">{error}</div>}
                        </div>
                </div>
        );
});

export default Form;